import { acceptHMRUpdate, defineStore } from "pinia";

interface IBreadcrumb {
  name: string;
  link: string;
}
export const useBreadcrumbStore = defineStore("breadcrumb", () => {
  const links = ref<IBreadcrumb[]>([]);

  return {
    links
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useBreadcrumbStore, import.meta.hot));